<ez-main-layout>
  <p>
    Die automatisierte Überprüfung Ihrer Daten konnte nicht erfolgreich abgeschlossen werden. Bitte versuchen Sie es
    erneut.
  </p>
  <p>
    Falls das Problem weiter besteht, wenden Sie sich gerne an uns. Die Kontaktdaten finden Sie in unserem Anschreiben.
  </p>
</ez-main-layout>
